import { MeasurementStatus } from 'core/constant/MeasurementStatus';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';
import { buildMeasurement } from 'core/service/measurements/measurementUtils';
import { MeasurementName } from 'core/constant/MeasurementName';
import { IMeasurementTags } from '@agoda/messaging-client';
import { sendMeasurement } from 'core/messaging/measurement/measurement';
import { logInfo, logWarn } from 'core-framework/util/LogMessage';

const sendCuscoCampaignsApiMeasurement = (
    message: string,
    measurementName: MeasurementName,
    pageTypeId: ActivitiesPageTypes,
    config: BootstrapConfig,
    tags: IMeasurementTags,
): boolean => {
    const measurement = buildMeasurement('cusco_campaigns', measurementName, pageTypeId, message, 1, false, config);
    measurement.tags = {
        ...measurement.tags,
        ...tags,
    };

    sendMeasurement({ ...measurement, name: MeasurementName.CuscoCampaignsStatus }, pageTypeId);

    if (measurementName === MeasurementName.CuscoCampaignsSuccess || measurementName === MeasurementName.CuscoCampaignsNoResults) {
        logInfo(message, pageTypeId, measurement.tags);
        return true;
    }
    logWarn(message, pageTypeId, measurement.tags);
    return true;
};

export const measureCuscoCampaignsApiResponse = (status: MeasurementStatus, response: string, message: string, config: BootstrapConfig, pageTypeId: ActivitiesPageTypes) => {
    const measurementTags: IMeasurementTags = {
        status,
    };
    if (status === MeasurementStatus.Success) {
        if (!response.length) {
            return sendCuscoCampaignsApiMeasurement('empty contentMetaInfo', MeasurementName.CuscoCampaignsNoResults, pageTypeId, config, measurementTags);
        }
        return sendCuscoCampaignsApiMeasurement('success', MeasurementName.CuscoCampaignsSuccess, pageTypeId, config, measurementTags);
    }
    measurementTags.status = MeasurementStatus.Failed;
    return sendCuscoCampaignsApiMeasurement(message, MeasurementName.CuscoCampaignsError, pageTypeId, config, measurementTags);
};
